import FeaturesConfig from '../../../config/features.json'

/**
 * Determine whether or not should default unilateral recipient country to sender country
 * @param {string} senderCountryCode - sender country code
 * @returns {boolean} whether or not to default unilateral recipient country to sender country
 */
export function defaultUnilateralRecipientToSenderCountry(senderCountryCode) {
  const countryFeatures = FeaturesConfig[senderCountryCode] || {}

  return Boolean(countryFeatures.defaultUnilateralRecipientCountry)
}
